import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Card, ScreenReaderContainer } from 'components';
import { Icon, Text } from 'components/chroma';

import { RefDataType } from 'scenes/common/types';

const toSpecialDetailDescription = ({ value, label }: RefDataType): string => {
  switch (value) {
    case 'Deadlocks':
      return 'Deadlocks, deadbolts or equivalents on all external doors';
    case 'Windowlock':
      return 'Locks that require a key, on all opening windows';
    case 'Windowbars':
      return 'Bars, grilles or security screens on all windows';
    case 'B2BAlarm':
      return 'An alarm that is monitored by a third party';
    case 'LocAlarm':
      return 'An alarm that is not monitored by a third party';
    case 'NoAlarm':
      return 'None of the above';
    default:
      return label;
  }
};

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SecurityFeatureCard: FunctionComponent<{
  securityFeature: RefDataType;
  selected: boolean;
  onClick: () => void;
  screenReaderText: string;
}> = ({ securityFeature, selected, onClick, screenReaderText }) => (
  <Card
    id={securityFeature.value}
    selected={selected}
    center
    onClick={onClick}
    role="button"
  >
    <CardWrapper
      data-testid={`${securityFeature.value}${selected ? '-selected' : ''}`}
    >
      <Icon name="checkCircle" margin={{ right: 5 }} />
      <Text>{toSpecialDetailDescription(securityFeature)}</Text>
      <ScreenReaderContainer>{screenReaderText}</ScreenReaderContainer>
    </CardWrapper>
  </Card>
);
